import { createWorkOrderTemplate } from '#/graphql/mutations';
import type { WorkOrderTemplate, CreateWorkOrderTemplateMutation } from '#/graphql/types';
import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import { SubmitWorkOrderTemplate } from '../utils/types';

const q = gql(createWorkOrderTemplate);

const useWOTemplateCreate = () => {
  const [mutation, result] = useMutation<CreateWorkOrderTemplateMutation>(q);

  const createWOTemplate = useCallback(
    async (woTemplate: WorkOrderTemplate) => {
      const {
        __typename,
        id,
        createdAt,
        createdBy,
        updatedAt,
        updatedBy,
        createdByUser,
        updatedByUser,
        ...woTemplateInput
      } = woTemplate;

      const response = await mutation({
        variables: {
          data: woTemplateInput,
        },
      });

      return response.data?.createWorkOrderTemplate ?? undefined;
    },
    [mutation],
  ) as SubmitWorkOrderTemplate;

  return { createWOTemplate, result };
};

export default useWOTemplateCreate;
